import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from "../../shared/shared.module";

import { InstructionsComponent } from './components/instructions.component';

import { PipeTransformPipe } from '../../shared/pipe/pipe-transform.pipe';
import { InstructionEnglishComponent } from './components/instruction-english.component';
import { InstructionsSinhalaComponent } from './components/instructions-sinhala.component';
import { InstructionsTamilComponent } from './components/instructions-tamil.component';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [InstructionsComponent, PipeTransformPipe, InstructionEnglishComponent, InstructionsSinhalaComponent, InstructionsTamilComponent]
})
export class InstructionsModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/instructions/instructions.module.ts